function updateSelectOptions($selectElement, generatedParams) {
    $selectElement.find("option").each(function () {
        var $option = $(this);
        
        var baseValue = $option.val().split('&sz=')[0];
        var szParam = $option.val().match(/&sz=\d+/);
        szParam = szParam ? szParam[0] : '';

        $option.val(`${baseValue}${szParam}&${generatedParams}`);
    });
}

function extractFilters(url) {
    const urlObj = new URL(url, window.location.origin);
    const params = new URLSearchParams(urlObj.search);
    const filteredParams = new URLSearchParams();
    params.forEach((value, key) => {
        if (key !== 'cgid' && key !== 'srule') {
            filteredParams.append(key, value);
        }
    });
    return filteredParams.toString();
}
module.exports = {
    updateSelectOptions:updateSelectOptions,
    extractFilters:extractFilters
};